<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">TVC Spot Rate 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row >
        <b-col lg="3">
            <b-input-group >
                <b-input-group-prepend><span class="pt-2 mr-2">Program Group</span></b-input-group-prepend>
                <b-form-select v-model="filter.groupname" :plain="true" :options="filtergroups"></b-form-select>
            </b-input-group>
        </b-col>
        <b-col md="5">
              <b-row>
                <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                <b-button class="btn btn-secondary mr-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
              </b-row>
        </b-col>

      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(spotprice)="data">
          {{uanguser}} {{data.item.spotprice|numFormat}}
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="6">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="6">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="6" lg="4">
        <b-card>
          <div slot="header">TV Spot Rate - Add/Edit Form 
          </div>
                  <b-form-group  label-cols=3  label="Program Group" >
                      <b-form-select  v-model="frmdata.groupprog" :plain="true" :options="groups" :state="!$v.frmdata.groupprog.$error"></b-form-select>
                  </b-form-group>
                  <b-form-group  label-cols=3  label="Program Rate" >
                      <b-form-select  v-model="frmdata.spotrate" :plain="true" :options="spotrates" ></b-form-select>
                  </b-form-group>
                  <b-form-group  label-cols=3  label="Rate Price" >
                    <b-input-group >
                        <b-input-group-prepend>
                            <span class="input-group-text">{{uanguser}}</span>
                        </b-input-group-prepend>
                        <my-number class="form-control text-right" v-model="frmdata.spotprice" :precision="2" :state="!$v.frmdata.spotprice.$error"></my-number>
                    </b-input-group>

                  </b-form-group>

            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>

        </b-card>
        </b-col>
      </b-row>

  </div>
</template>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        spotprice: { required },
        spotrate: { required },
        groupprog: { required },
    },
  }, 
  components:{myNumber},
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList:true,
      showForm:false,
      frmdata:{spotrate:'',spotprice: '',groupprog:''},
      groups:[],spotrates:['','SOFTNEWS','HARDNEWS'], filtergroups:[{value:'', text:'--ALL--'}],
      uanguser: this.$store.state.user.matauang,
      tblData: {
        tablename:'vwtvspotrate',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false
      },
      filter:{ groupname:''}
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "groupname",
            label: "Program Group",
            sortable: true
          },
          {
            key: "spotrate",
            label: "Program Rate",
            sortable: true
          },
          {
            key: "spotprice",
            label: "Spot Price",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: async function () {
        const [a,b] = await Promise.all([
          crud.list({
            tablename:'programtv-group',
            page: 1,
            limit: 1000,
            total: 0,
            sortBy: 'seqno',
            sortDesc: false
          }),crud.list({
            tablename:'programrate',
            page: 1,
            limit: 1000,
            total: 0,
            sortBy: 'seqno',
            sortDesc: false
          })]);
        this.groups = a.reduce((newArr,item) =>{
            newArr.push({ value: item.kode, text: item.nama});
            return newArr;
        },[]);
        // this.filtergroups = a.reduce((newArr,item) =>{
        //     newArr.push({ value: item.kode, text: item.nama});
        //     return newArr;
        // },[{value:'', text:'--ALL--'}]);
        this.filtergroups=this.filtergroups.concat(this.groups);
        this.spotrates = b.reduce((newArr,item) =>{
            newArr.push({ value: item.kode, text: item.nama});
            return newArr;
        },[]);

  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.customQuery='';
      if (this.filter.groupname){
        this.tblData.customQuery = 'groupprog=' + encodeURIComponent(this.filter.groupname);
      }

      const list = await crud.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.filter.groupname= '';
        this.refresh();
    },

    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data.tablekey;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              if (this.frmdata.idlama) {
                await crud.update(
                     {tablename:'tvspotrate', 
                     key:this.frmdata.idlama, 
                     data:{spotprice:this.frmdata.spotprice, spotrate:this.frmdata.spotrate,groupprog:this.frmdata.groupprog}
                      });
              } else {
                await crud.insert(
                  { tablename:'tvspotrate',                      
                     data:{spotprice:this.frmdata.spotprice, spotrate:this.frmdata.spotrate,groupprog:this.frmdata.groupprog}
                  });
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'tvspotrate', key:this.model.tablekey});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
